

<template>
      <v-dialog
         v-model="dialog"
         width="600px"
         >
         <template v-slot:activator="{ on, attrs }">
            <v-icon v-on="on" color="primary">search</v-icon>
         </template>
         <v-card>
            <v-card-title>
               <span class="headline">{{ $t("locationSearch") }}</span>
            </v-card-title>
            <v-card-text>
               <ApiForm
                  :formElements="formElements"
                  :dense="true"
                  :successFn="success"
                  @formReset="closeDialog"
                  :submit='{ text: "$search", color: "primary" }'
                  :cancel='{ text: "$cancel", color: "secondary" }'
                  method="GET"
                  endpoint="routeoptimizer/locationIqSearch"
                  ></ApiForm>
               <v-card v-if="displayItems.length"
                  class="mx-auto mt-3"
                  >
                  <v-list three-line>
                     <v-list-item-group
                        v-model="selectedItem"
                        color="primary"
                        >
                        <template v-for="(item, index) in displayItems">
                           <v-subheader
                              v-if="item.header"
                              :key="item.header"
                              v-text="item.header"
                              ></v-subheader>
                           <v-divider
                              v-else-if="item.divider"
                              :key="index"
                              :inset="item.inset"
                              ></v-divider>
                           <v-list-item
                              v-else
                              :key="item.title"
                              >
                              <v-list-item-avatar>
                                 <v-img v-if="item.avatar" :src="item.avatar"></v-img>
                              </v-list-item-avatar>
                              <v-list-item-content>
                                 <v-list-item-subtitle v-html="item.subtitle"></v-list-item-subtitle>
                              </v-list-item-content>
                           </v-list-item>
                        </template>
                     </v-list-item-group>
                  </v-list>
               </v-card>
            </v-card-text>
         </v-card>
      </v-dialog>
</template>


<script>
export default {
  data() {
    return {
      dialog: false,
      selectedItem: undefined,
      formElements: [
        {
          key: 'location',
          label: '$location'
        }
      ],
      displayItems: [],
      resultElements: []
    }
  },
  methods: {
    success(data) {
      this.displayItems = []
      this.resultElements = data
      this.displayItems.push({ header: 'Result' })

      let that = this
      data.forEach(x => {
        that.displayItems.push({
          subtitle: x.address,
          avatar: x.iconUrl
        })
        that.displayItems.push({ divider: true, inset: true })
      })

      this.displayItems.pop()
    },
    closeDialog() {
      this.dialog = false
      this.displayItems = []
      this.resultElements = []
      this.selectedItem = undefined
    }
  },
  watch: {
    selectedItem: {
      handler() {
        if (this.selectedItem == undefined) {
          return
        }

        this.$emit('locationChoosen', this.resultElements[this.selectedItem])
        this.dialog = false
        this.displayItems = []
        this.resultElements = []
        this.selectedItem = undefined
      }
    }
  }
}
</script>
